module.exports = __webpack_public_path__ + "iconfont.ttf?323764f983e0c86be7b5607b4fdaa7cf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.ttf?t=1612683013658
// module id = 25
// module chunks = 0